export default __webpack_public_path__ + "static/media/i_bus-tro_gy_tagless.334fd55b.svg";